import { Loading } from '@farmshare/ui-components';
import { useRecoilValue } from 'recoil';

import { userState } from 'state';
import { isBuyerOnly } from 'lib/userHelpers';

import { BuyerDashboard } from './buyer/buyer-dashboard';
import { ProducerDashboardTabs } from './producer/producer-dashboard/producer-dashboard-tabs';

export function DashboardRouter() {
  const user = useRecoilValue(userState);

  if (!user) return <Loading />;
  if (isBuyerOnly(user)) return <BuyerDashboard />;
  return <ProducerDashboardTabs />;
}
